/* tslint:disable */
/* eslint-disable */
/**
/* This file was automatically generated from pydantic models by running pydantic2ts.
/* Do not modify it by hand - just update the pydantic models and then re-run the script
*/

export interface JourneyOptionsMessage {
  event_type?: "journey_options";
  journey_options: JourneyOption[];
}
export interface JourneyOption {
  journey_id: string;
  headline: string;
  /**
   * Brief real life story description, must be 30 words or less.
   */
  brief_real_life_story_description: string;
  benefits_to_user_and_why_its_relevant: string;
  skill_to_learn: string;
}
export interface LessonArch {
  episode_number: number;
  episode_title: string;
  cliff_hanger_into_next_episode: string;
  skill_to_learn_in_this_episode: string;
}
export interface MCQFeedbackBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type?: "mcq_feedback";
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: MCQFeedbackParamsToProduce;
  content: MCQFeedbackParamsToProduce;
}
export interface MCQFeedbackParamsToProduce {
  feedback: string;
  poem: string;
}
export interface TextInputQuestionResultingProps {
  question: string;
}
export interface ErrorMessage {
  event_type?: "error";
  error: string;
}
export interface SprintLessonBlueprint {
  story_context: MarkdownContentBlockToProduce;
  story_image: ImageContentBlockToProduce;
  story_lesson_analysis: MarkdownContentBlockToProduce;
  mcq: MCQBlockToProduce;
}
/**
 * Used for LLM prompting to define the expected structure of markdown blocks
 */
export interface MarkdownContentBlockToProduce {
  block_type: "markdown_content";
  arguments: MarkdownContentParamsToProduce;
  [k: string]: unknown;
}
export interface MarkdownContentParamsToProduce {
  raw_markdown: string;
}
/**
 * Used for LLM prompting to define the expected structure of image blocks
 */
export interface ImageContentBlockToProduce {
  block_type: "image_content";
  arguments: ImageContentParamsToProduce;
  [k: string]: unknown;
}
export interface ImageContentParamsToProduce {
  image_web_search_query: string;
  source_link: string;
}
/**
 * Used for LLM prompting to define the expected structure of MCQ blocks
 */
export interface MCQBlockToProduce {
  block_type: "mcq";
  arguments: MCQParamsToProduce;
  [k: string]: unknown;
}
export interface MCQParamsToProduce {
  question: string;
  options: string[];
}
export interface NavigationUpdateMessage {
  event_type?: "navigation_update";
  navigation_result: NavigationResult;
}
export interface NavigationResult {
  view?: string | null;
  journey_id?: string | null;
  lesson_id?: string | null;
}
export interface BlocksUpdateMessage {
  event_type?: "blocks_update";
  blocks: unknown[];
  sequence?: number | null;
  lesson_schema?: string | null;
}
export interface NonSchemaBlocksUpdateMessage {
  event_type?: "non_schema_blocks_update";
  blocks: unknown[];
  sequence?: number | null;
}
export interface ImageContentBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type?: "image_content";
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: ImageContentParamsToProduce;
  content: ImageContentResultingProps;
}
export interface ImageContentResultingProps {
  url: string;
}
export interface MarkdownContentResultingProps {
  raw_markdown: string;
}
/**
 * A block that displays a text input question
 */
export interface TextInputQuestionBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type?: "text_input_question";
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: TextInputQuestionParamsToProduce;
  content: TextInputQuestionResultingProps;
}
export interface TextInputQuestionParamsToProduce {
  question: string;
}
export interface MCQBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type?: "mcq";
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: MCQParamsToProduce;
  content: MCQResultingProps;
}
export interface MCQResultingProps {
  question: string;
  options: string[];
}
export interface JourneyOptions {
  journey_options: JourneyOption[];
}
/**
 * The order of these fields matter.
 *
 * So far, the "metadata" field must come early, ideally before params and content.
 * That's because we use the metadata field to store the feedback_for_block_key,
 * which in turn is used to associate a feedback block with a specific block as early
 * as possible (so we can show streaming feedback asap [instead of waiting for this portion
 * to come and then associate the block at that point] when using the block streaming
 * engine for feedback purposes).
 */
export interface BaseBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type: string;
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: unknown;
  content: unknown;
}
/**
 * A block that displays markdown content
 */
export interface MarkdownContentBlock {
  index_key: string;
  metadata?: {
    [k: string]: unknown;
  } | null;
  state: "pending" | "success" | "error";
  block_type?: "markdown_content";
  is_block_complete: boolean;
  is_metadata_complete: boolean;
  tool_params_to_produce_content: MarkdownContentParamsToProduce;
  content: MarkdownContentResultingProps;
}

// ==================== Enum Types ====================

// Generated from WebSocketEventType Enum
export enum WebSocketEventType {
    JOURNEY_OPTIONS = "journey_options",
    BLOCKS_UPDATE = "blocks_update",
    NON_SCHEMA_BLOCKS_UPDATE = "non_schema_blocks_update",
    NAVIGATION_UPDATE = "navigation_update",
    ERROR = "error",
    CONNECTION_STATE = "connection_state",
}

// ==================== Union Types ====================
// Generated WebSocketMessage union type
export type WebSocketMessage = JourneyOptionsMessage | BlocksUpdateMessage | NonSchemaBlocksUpdateMessage | NavigationUpdateMessage | ErrorMessage;

// Generated Block union type
export type Block = TextInputQuestionBlock | MarkdownContentBlock | MCQBlock | ImageContentBlock | MCQFeedbackBlock;
